module.exports = __webpack_public_path__ + "static/media/red_icon.2f7c27c1.svg";